enum PostingScheduleType {
    FixedSchedule = "FIXED_SCHEDULE",
    AnniversaryAccountOpen = "ANNIVERSARY_ACCOUNT_OPEN",
    AnniversaryFirstTransaction = "ANNIVERSARY_FIRST_TRANSACTION"
}
export default PostingScheduleType